import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getServizio, getDatiAzienda } from '../services/api';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import '../print.css';

function ServiziPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [servizio, setServizio] = useState(null);
  const [datiAzienda, setDatiAzienda] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServizioAndAziendaData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [servizioResponse, aziendaResponse] = await Promise.all([
          getServizio(id),
          getDatiAzienda()
        ]);
        setServizio(servizioResponse.data);
        setDatiAzienda(aziendaResponse.data);
      } catch (err) {
        setError('Errore nel caricamento dei dati per la stampa.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchServizioAndAziendaData();
  }, [id]);

  useEffect(() => {
    const handleAfterPrint = () => {
      setTimeout(() => {
        navigate('/servizi');
      }, 100);
    };

    if (!loading && !error && servizio && datiAzienda) {
      window.addEventListener('afterprint', handleAfterPrint);
      window.print();
    }

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, [loading, error, servizio, datiAzienda, navigate]);

  const renderField = (label, value) => (
    <Row className="mb-2">
      <Col xs={5}><span className="label">{label}:</span></Col>
      <Col xs={7}><span className="value">{value || 'N/A'}</span></Col>
    </Row>
  );

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Preparazione stampa servizio...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <p>Impossibile preparare la stampa.</p>
      </Container>
    );
  }

  if (!servizio || !datiAzienda) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Dati del servizio o dell'azienda non trovati per la stampa.</Alert>
      </Container>
    );
  }

  return (
    <div id="printable-area" className="portrait-page">
      <div className="print-container">
        <header className="print-header">
          <div className="company-details">
            {datiAzienda.logo_url && (
              <img
                src={`${process.env.REACT_APP_STATIC_FILES_BASE_URL}${datiAzienda.logo_url}`}
                alt="Logo Azienda"
                style={{ maxHeight: '150px', maxWidth: '150px', marginRight: '20px', objectFit: 'contain' }}
              />
            )}
          </div>
          <div className="print-info">
            <p><strong>Data di Stampa:</strong> {new Date().toLocaleDateString()}</p>
            <p><strong>ID Servizio:</strong> {servizio.id}</p>
          </div>
        </header>

        <main>
          <h2 className="document-title text-center">{servizio.descrizione}</h2>

          <section className="print-section">
            <div className="print-section-title">DETTAGLI SERVIZIO</div>
            <div className="print-section-content">
                {renderField('SKU', servizio.sku)}
                {renderField('Categoria', servizio.categoria)}
                {renderField('Descrizione', servizio.descrizione)}
            </div>
          </section>

          <section className="print-section">
            <div className="print-section-title">PREZZI</div>
            <div className="print-section-content">
                {renderField('Prezzo', servizio.prezzo ? `€ ${servizio.prezzo.toFixed(2)}` : 'N/D')}
                {renderField('IVA', servizio.iva ? `${servizio.iva}%` : 'N/D')}
            </div>
          </section>
        </main>

        <footer className="print-footer">
          <p>{datiAzienda.denominazione} - {datiAzienda.indirizzo} - {datiAzienda.cap} {datiAzienda.citta} ({datiAzienda.provincia}) - P.IVA {datiAzienda.piva}</p>
          <p>Email: {datiAzienda.email} - Tel: {datiAzienda.tel}</p>
        </footer>
      </div>
    </div>
  );
}

export default ServiziPrint;
